import { types } from 'mobx-state-tree';
import { model, Model } from 'mst-collection';

import { LanguageCodesEnum } from '@constants';

export class SignUpDraft extends Model({
  email: types.string,
  password: types.string,
  firstName: types.string,
  lastName: types.string,
  countryCode: types.string,
  language: types.enumeration(Object.values(LanguageCodesEnum)),
}) {}

export const SignUpDraftModel = model(SignUpDraft);
